/* Envoise 2.0 cart drawer: one-tap add / remove for the upsells, then refresh the theme's cart drawer */
(function () {
  if (window.__ev2Cart) return;
  window.__ev2Cart = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function post(path, body, btn) {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.getSectionsToRender === 'function') {
      body.sections = cd.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'Cart error');
        if (cd && typeof cd.renderContents === 'function' && res.sections) {
          cd.classList.remove('is-empty');
          cd.renderContents(res);
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.href = root + 'cart'; });
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-ev2-cart-add]');
    if (add) {
      e.preventDefault();
      post('cart/add.js', { items: [{ id: Number(add.getAttribute('data-ev2-cart-add')), quantity: 1 }] }, add);
      return;
    }
    var rm = e.target.closest('[data-ev2-cart-remove]');
    if (rm) {
      e.preventDefault();
      post('cart/change.js', { id: rm.getAttribute('data-ev2-cart-remove'), quantity: 0 }, rm);
    }
  });
})();
